// A file viewer's "…" on a phone (documents/blocks/media/file-lightbox.tsx):
// a drawer from the bottom with a row per action, as in the old web, instead
// of the small menu at the button.
//
// Promise:
// - Drawn in the viewer's own layer (above the image), not in the screen's
//   overlay host: the viewer lies over the whole page.
// - A row is 44 px high; pressing one closes the drawer, gives the focus back
//   to "…", and runs it.
import { m } from "@trameria/i18n";
import type { MediaMoreProps } from "../documents/blocks/media/media-more-port";
import { BottomDrawer } from "./bottom-drawer";

export function MediaMoreDrawer({
  open,
  label,
  items,
  onClose,
  opener,
}: MediaMoreProps) {
  return (
    <BottomDrawer
      open={open}
      label={label}
      closeLabel={m.media_close()}
      onClose={onClose}
      opener={opener}
    >
      <div className="flex flex-col">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className="flex min-h-11 w-full cursor-pointer items-center rounded-[10px] px-3 text-left text-[15px] text-body hover:bg-hover active:bg-hover"
            onClick={() => {
              opener.current?.focus({ preventScroll: true });
              onClose();
              item.run();
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </BottomDrawer>
  );
}
